import React, { useEffect, useState } from "react";
import dots from "../assets/images/dots.svg";
import { Link,useParams } from "react-router-dom";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import { SpinnerCircular } from "spinners-react";
import ReactPaginate from "react-paginate";
import { Dropdown, Space, Modal } from "antd";
import { DownOutlined } from "@ant-design/icons";
import moment from "moment";

const SearchApp = (props) => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  let employees = props.data;
  let loading = props.loader;
  let lastPageNumber = props.pagen;
  let lastPage = props.page1;

  const handleChange = (event) => {
    let searchValue = event.target.value;
    setPage(0);
    setSearch(searchValue);
  };
  const handlePage = (page) => {
    setPage(page);
  };
  let searchString = search.trim().toLowerCase();

  if (searchString.length > 0) {
    employees = employees.filter((e) =>
      e.firstname.toLowerCase().match(searchString) || e.email.toLowerCase().includes(searchString)
    );
    
  }
  return (
    <div class="wrapper">
      <Nav />
      <div id="content">
        <header>
          <div class="dashboard_header">
            <div class="left-side d-flex ">
              {" "}
              <button
                type="button"
                id="sidebarCollapse"
                class="btn btn-link bt_none"
              >
                <i class="fa fa-align-left"></i>{" "}
              </button>
              <h1>Evo History</h1>
            </div>
            <div class="user_profile   ">
              <DropdownRight />
            </div>
          </div>
        </header>
        <UserInput
          update={(e) => handleChange(e)}
          handlePage={(page) => handlePage(page)}
        />
        <Table
          data={employees}
          loader={loading}
          page={page}
          handlePage={(page) => handlePage(page)}
          lastPage={lastPage}
          lastPageNumber={lastPageNumber}
          refreshTable={props.refreshEvoList}
        />
      </div>
    </div>
  );
};
const Table = (props) => {


  let loading = props.loader;
  let lastPage = props.lastPage;
//   let lastPageNumber = props.lastPageNumber;

  const usersPerPage = 7;
  const pagesVisited = props.page * usersPerPage;
  let lastPageNumber = (props.data.length % usersPerPage == 0 ? usersPerPage : props.data.length % usersPerPage)


  const pageCount = Math.ceil(props.data.length / usersPerPage);
  const listEvo = props.data.length;
  const [pageNumber, setPageNumber] = useState(0);
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [deleteTeamId, setDeleteTeamId] = useState(0);
  const [deleteTeamName, setDeleteTeamName] = useState("");
  const [error, setError] = useState("");

  const changePage = ({ selected }) => {
    props.handlePage(selected);
    setPageNumber(selected);
  };



  return (
    <>
      <div class="table_vedio_upload dashbord_table    team_table mb_30 over_flow mb-0">
        <table class="table table-borderless table-responsive-md">
          <thead>
            <tr>
              <th scope="col" className="">
                Parent Name
              </th>
              <th scope="col" className="" >
                Email
              </th>
              <th scope="col" className=" ">
                Evo Date
              </th>
              <th scope="col" className=" ">
                Evo Price
              </th>
              <th scope="col" className="">
                Split Price
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <div
                style={{
                  position: "absolute",
                  marginTop: 250,
                  backgroundColor: "#ffffffc2",
                  marginLeft: 580,

                  backgroundBlendMode: "overlay",
                  zIndex: 100,
                }}
              >
                <SpinnerCircular size="15%" />
              </div>
            ) : (
              <>
                {props.data
                  .slice(pagesVisited, pagesVisited + usersPerPage)
                  .map(function (d, i) {
                    return (
                      <TableRow
                        key={"person-" + i}
                        parent_name={d.firstname}
                        email={d.email}
                        evo_date={d.evo_date}
                        evo_price={d.price}
                        split_price={d.evo_split_price}
                      />
                    );
                  })}
              </>
            )}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <div className="paginateText">
          <p className="text-table-show">
            {" "}
            Showing{" "}
            {/* {pageNumber === lastPage - 1 ? lastPageNumber : usersPerPage} out of{" "} */}
            {listEvo != 0 ? (props.page === pageCount - 1 ? (pagesVisited + 1 + '-' + (pagesVisited + lastPageNumber)) : (pagesVisited + 1 + '-' + (pagesVisited + usersPerPage))) : 0} out of{" "}
            {listEvo} entries
          </p>
        </div>
        <div className="reactPaginate">
          <ReactPaginate
            previousLabel={"<<"}
            nextLabel={">>"}
            pageCount={pageCount}
            onPageChange={changePage}
            containerClassName={"paginationBttns"}
            previousLinkClassName={"previousBttn"}
            nextLinkClassName={"nextBttn"}
            disabledClassName={"paginationDisabled"}
            activeClassName={"paginationActive"}
          />
        </div>
      </div>
    </>
  );
};

const UserInput = (props) => {
  return (
    <div class="analysts-wraper-head">
      <div class="form-group search_wraper">
        <input
          onChange={(e) => {
            props.update(e);
            props.handlePage(0);
            //  changePage({ selected: 0 });
          }}
          name=""
          class="form-control custom_input"
          placeholder="Search here"
        />
      </div>
      {/* <div class="map_btn">
        <Link to="/newTeams" class="them_btn">
          Add New Team
        </Link>
      </div> */}
    </div>
  );
};

const TableRow = (props) => {
 
  return (
    <tr>
      <td>{props.parent_name}</td>
      <td style={{wordBreak: "break-all"}}>{props.email}</td>
      <td>{moment(props.evo_date).format("DD MMM, YYYY")}</td>
      {/* <td>{props.evo_date}</td> */}
      <td>${props.evo_price}</td>
      <td>${props.split_price}</td>
    </tr>
  );
};

export default function EvoHistory() {
  const params = useParams();  
  const token = localStorage.getItem("xAuthToken");
  const [evoHistoryDetails, setEvoHistoryDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [lastPageNumber, setLastPageNumber] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const usersPerPage = 7;

  useEffect(() => {
    EvoHistory();
  }, []);


  const EvoHistory = async () => {
    setLoading(true);

    http
      .get(`api/admin/evo-history/${params.id}?token=${token}`)
      .then((res) => {
        setLoading(false);
        setEvoHistoryDetails(res.data.data);
        setLastPageNumber(res.data.data.length % usersPerPage == 0 ? usersPerPage : res.data.data.length % usersPerPage);
        setLastPage(Math.ceil(res.data.length / usersPerPage));
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  const refreshEvoHistoryList = () => {
    EvoHistory();
  };
  return (
    <>
      <SearchApp
        data={evoHistoryDetails}
        loader={loading}
        pagen={lastPageNumber}
        page1={lastPage}
        refreshEvoList={refreshEvoHistoryList}
      />
    </>
  );
}
